var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sparkline',{staticClass:"pcapsparkline",attrs:{"value":_vm.value,"color":"blue","line-width":"4","stroke-linecap":"round","fill":"","smooth":"15","gradient":['#42b3f4', '#99b7d8']}})}
var staticRenderFns = []

export { render, staticRenderFns }